import React from 'react';

export const AdultsOnlyFemaleMasturbationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.52 41.1599C14.4 41.1599 7.78003 34.5399 7.78003 26.4199C7.78003 18.2999 14.4 11.6799 22.52 11.6799C30.64 11.6799 37.26 18.2999 37.26 26.4199C37.26 34.5399 30.64 41.1599 22.52 41.1599ZM22.52 19.6599C18.8 19.6599 15.78 22.6799 15.78 26.3999C15.78 30.1199 18.8 33.1399 22.52 33.1399C26.24 33.1399 29.26 30.1199 29.26 26.3999C29.26 22.6799 26.24 19.6599 22.52 19.6599Z"
        fill="#C13870"
      />
      <path d="M26.52 37.1599H18.52V59.0399H26.52V37.1599Z" fill="#C13870" />
      <path d="M33.4401 44.0999H11.5601V52.0999H33.4401V44.0999Z" fill="#C13870" />
      <path
        d="M21.02 39.6599C12.9 39.6599 6.28003 33.0399 6.28003 24.9199C6.28003 16.7999 12.9 10.1799 21.02 10.1799C29.14 10.1799 35.76 16.7999 35.76 24.9199C35.76 33.0399 29.14 39.6599 21.02 39.6599ZM21.02 18.1799C17.3 18.1799 14.28 21.1999 14.28 24.9199C14.28 28.6399 17.3 31.6599 21.02 31.6599C24.74 31.6599 27.76 28.6399 27.76 24.9199C27.76 21.1999 24.74 18.1799 21.02 18.1799Z"
        fill="#FF6AA0"
      />
      <path d="M25.02 35.6599H17.02V57.5399H25.02V35.6599Z" fill="#FF6AA0" />
      <path d="M31.9601 42.5999H10.0801V50.5999H31.9601V42.5999Z" fill="#FF6AA0" />
      <path
        d="M37.02 12.36C34.54 14.48 31.72 15.58 27.82 15.92C26.46 16.04 25.78 17.78 27.5 19.36C29.96 21.64 32.7 20.84 33.94 20.32L34.52 20.08C34.52 20.08 35.46 20.1 36.66 19.96C35.58 21.96 36.12 24.76 37.92 27.1C39.78 29.52 42.68 34.8 44.56 37.22C46.82 40.14 51.02 40.66 53.4 38.74C53.4 38.74 66.08 28.62 57.04 17.12C49.98 8.11996 39.5 10.24 37 12.38L37.02 12.36Z"
        fill="#FFDD67"
      />
      <path
        d="M39.28 17.54C40.56 16.5 42.56 16.74 43.74 18.04H43.76C44.94 19.38 44.86 21.28 43.58 22.3L23.62 38.44C22.34 39.48 20.34 39.26 19.16 37.94H19.14C17.96 36.6 18.04 34.7 19.32 33.66L39.28 17.54Z"
        fill="#FFDD67"
      />
      <path
        d="M34.8401 27.52L22.1001 37.82C21.4001 38.38 20.5001 38.68 19.3201 38.12C20.6601 39.48 22.4801 39.36 23.6001 38.46L36.3401 28.16C37.6201 27.12 36.1201 26.48 34.8401 27.52Z"
        fill="#EBA352"
      />
      <path
        d="M40.26 24.8599C41.54 23.8199 43.54 24.0399 44.72 25.3599H44.74C45.92 26.6999 45.84 28.5999 44.56 29.6199L24.6 45.7599C23.32 46.7999 21.32 46.5799 20.14 45.2599C18.96 43.9199 19.04 42.0199 20.32 40.9999L40.28 24.8599H40.26Z"
        fill="#FFDD67"
      />
      <path
        d="M38.5 32.6799L23.1 45.1399C22.4 45.6999 21.36 45.9399 20.34 45.4599C21.7 46.8199 23.6 46.7999 24.72 45.8999L40.02 33.3399C41.3 32.2999 39.8 31.6599 38.52 32.6999L38.5 32.6799Z"
        fill="#EBA352"
      />
      <path
        d="M46.44 27.9001C47.72 26.8601 49.72 27.1001 50.9 28.4001C52.08 29.7401 52 31.6401 50.72 32.6601L30.76 48.8001C29.48 49.8401 27.48 49.6201 26.3 48.3001C25.12 46.9601 25.2 45.0601 26.48 44.0401L46.44 27.9001Z"
        fill="#FFDD67"
      />
      <path
        d="M42.8601 37.1798L29.2601 48.1598C28.5601 48.7198 27.3201 48.9398 26.3201 48.2998C27.5401 49.7798 29.7001 49.8998 30.8201 48.9998L44.3601 37.8198C45.6401 36.7798 44.1401 36.1398 42.8601 37.1598V37.1798Z"
        fill="#EBA352"
      />
      <path
        d="M53.52 30.3999C54.8 29.3599 53.26 38.8399 51.98 39.8799L37.86 51.2999C36.58 52.3399 34.58 52.1199 33.4 50.7999H33.38C32.2 49.4599 32.28 47.5599 33.56 46.5399L53.52 30.3999Z"
        fill="#FFDD67"
      />
      <path
        d="M49.6201 11.52C49.6201 11.52 56.3401 14.86 59.0601 21.6C61.5001 27.64 56.0801 34.48 52.6401 37.48C48.9801 40.68 47.1201 42.3 37.5201 49.68C35.7001 51.08 34.62 51.32 33.3 50.66C34.42 52.42 36.82 52.34 37.92 51.44L38.8601 50.66C38.8601 50.66 50.1 41.7 53.76 38.62C57.0801 35.84 63.3601 27.92 60.3801 21C57.0801 13.3 49.6 11.5 49.6 11.5L49.6201 11.52Z"
        fill="#EBA352"
      />
      <path
        d="M37.7999 18.6399C35.6599 19.8199 33.18 19.2199 33.18 19.2199L32.5999 19.4599C31.5999 19.8599 29.68 20.4599 27.7 19.5399C30.08 21.8199 32.7399 20.9399 33.9599 20.4599L34.58 20.1999C34.58 20.1999 35.2799 20.4599 35.9599 20.2599L37.82 18.6399H37.7999Z"
        fill="#EBA352"
      />
    </svg>
  );
};
